import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = { class: "fdd-titles" }
const _hoisted_3 = { class: "fdd-headline" }
const _hoisted_4 = {
  key: 0,
  class: "fdd-states",
  "aria-label": "Today at a glance"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "fdd-chip-warn"
}
const _hoisted_7 = {
  key: 4,
  class: "fdd-chip-sign"
}
const _hoisted_8 = {
  key: 5,
  class: "fdd-chip-rec"
}
const _hoisted_9 = {
  key: 6,
  class: "fdd-chip-next"
}
const _hoisted_10 = { class: "fdd-pop-h" }
const _hoisted_11 = { class: "fdd-titles" }
const _hoisted_12 = { class: "fdd-headline" }
const _hoisted_13 = { class: "fdd-body" }
const _hoisted_14 = {
  key: 0,
  class: "fdd-loading",
  role: "status"
}
const _hoisted_15 = {
  key: 1,
  class: "fdd-error",
  role: "alert"
}
const _hoisted_16 = {
  key: 0,
  class: "fdd-summary"
}
const _hoisted_17 = { class: "fdd-chips" }
const _hoisted_18 = {
  key: 2,
  class: "fdd-chip-sign"
}
const _hoisted_19 = {
  key: 3,
  class: "fdd-chip-rec"
}
const _hoisted_20 = {
  key: 1,
  class: "fdd-sec fdd-deck"
}
const _hoisted_21 = { class: "fdd-deck-acts" }
const _hoisted_22 = {
  key: 2,
  class: "fdd-sec"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "fdd-when" }
const _hoisted_25 = { class: "fdd-main" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 3,
  class: "fdd-sec"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "fdd-main" }
const _hoisted_31 = {
  key: 4,
  class: "fdd-sec fdd-rec"
}
const _hoisted_32 = { class: "fdd-label" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "fdd-when" }
const _hoisted_35 = { class: "fdd-main" }
const _hoisted_36 = {
  key: 0,
  class: "fdd-hint"
}
const _hoisted_37 = {
  key: 5,
  class: "fdd-sec fdd-rocks"
}
const _hoisted_38 = { class: "fdd-label fdd-label-row" }
const _hoisted_39 = { class: "fdd-label-soft" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "fdd-when" }
const _hoisted_42 = { class: "fdd-main" }
const _hoisted_43 = { class: "fdd-sublabel" }
const _hoisted_44 = { class: "fdd-main" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 0,
  class: "fdd-item-error",
  role: "alert"
}
const _hoisted_47 = { class: "fdd-due-act" }
const _hoisted_48 = ["disabled", "onClick"]
const _hoisted_49 = {
  key: 1,
  class: "fdd-hint"
}
const _hoisted_50 = {
  key: 6,
  class: "fdd-sec"
}
const _hoisted_51 = { class: "fdd-label fdd-label-row" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "fdd-main" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 0,
  class: "fdd-item-error",
  role: "alert"
}
const _hoisted_56 = { class: "fdd-due-act" }
const _hoisted_57 = ["onUpdate:modelValue", "min", "aria-label"]
const _hoisted_58 = ["disabled", "onClick"]
const _hoisted_59 = ["disabled", "onClick"]
const _hoisted_60 = {
  key: 0,
  class: "fdd-hint"
}
const _hoisted_61 = {
  key: 7,
  class: "fdd-sec fdd-sign"
}
const _hoisted_62 = { class: "fdd-label" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "fdd-when" }
const _hoisted_65 = { class: "fdd-main" }
const _hoisted_66 = {
  key: 0,
  class: "fdd-hint"
}
const _hoisted_67 = {
  key: 8,
  class: "fdd-hint"
}
const _hoisted_68 = {
  key: 9,
  class: "fdd-hint"
}
const _hoisted_69 = { class: "fdd-foot" }
const _hoisted_70 = { class: "fdd-hint" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = {
  key: 10,
  class: "fdd-hint",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.hidden)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(["fdd", { 'fdd-button-mode': _ctx.buttonMode }]),
        "aria-labelledby": "fdd-title"
      }, [
        (!_ctx.buttonMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "fdd-bar",
              "aria-expanded": _ctx.open,
              "aria-haspopup": "dialog",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPop()))
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "fdd-icon" }, [
                _createElementVNode("svg", {
                  "aria-hidden": "true",
                  viewBox: "0 0 24 24",
                  fill: "currentColor",
                  "fill-rule": "evenodd"
                }, [
                  _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
                ])
              ], -1)),
              _createElementVNode("span", _hoisted_2, [
                _cache[13] || (_cache[13] = _createElementVNode("span", {
                  id: "fdd-title",
                  class: "fdd-title"
                }, "Daily Digest", -1)),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.loading ? 'The Forge is putting your day together…' : _ctx.digest ? _ctx.digest.headline : _ctx.error ? 'Not available right now' : ''), 1)
              ]),
              (_ctx.digest)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'fdd-chip-hot': _ctx.counts.overdue })
                    }, _toDisplayString(_ctx.counts.overdue || 0) + " overdue", 3),
                    (_ctx.counts.dueToday)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.counts.dueToday) + " due today", 1))
                      : _createCommentVNode("", true),
                    (_ctx.counts.noDueDate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.counts.noDueDate) + " no due date", 1))
                      : _createCommentVNode("", true),
                    (_ctx.milestoneChip)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass(_ctx.milestoneChip.cls)
                        }, _toDisplayString(_ctx.milestoneChip.text), 3))
                      : _createCommentVNode("", true),
                    (_ctx.rockCounts.rocks)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: _normalizeClass({ 'fdd-chip-warn': _ctx.rockCounts.off })
                        }, _toDisplayString(_ctx.rockChip), 3))
                      : _createCommentVNode("", true),
                    (_ctx.signCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.signCount) + " to sign", 1))
                      : _createCommentVNode("", true),
                    (_ctx.handoffCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.handoffChip), 1))
                      : _createCommentVNode("", true),
                    (_ctx.nextMeeting)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.nextMeeting), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "fdd-open-label" }, "Open", -1))
            ], 8, _hoisted_1))
          : _createCommentVNode("", true),
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "error-msg-wrap fdd-wrap",
              onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.closePop()), ["self"]))
            }, [
              _createElementVNode("div", {
                class: "form-wrapper slide-up fdd-pop",
                role: "dialog",
                "aria-modal": "true",
                "aria-label": "Daily Digest",
                tabindex: "-1",
                ref: "pop",
                onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.closePop()), ["prevent"]), ["esc"]))
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "fdd-close",
                  title: "Close",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closePop()))
                }, "×"),
                _createElementVNode("div", _hoisted_10, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "fdd-icon" }, [
                    _createElementVNode("svg", {
                      "aria-hidden": "true",
                      viewBox: "0 0 24 24",
                      fill: "currentColor",
                      "fill-rule": "evenodd"
                    }, [
                      _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "fdd-title" }, "Daily Digest", -1)),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.loading ? 'The Forge is putting your day together…' : _ctx.digest ? _ctx.digest.headline : ''), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("div", { class: "fdd-orb" }, null, -1),
                        _createTextVNode("Reading your meetings, decks and to-dos…", -1)
                      ]))]))
                    : (_ctx.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.load()), ["prevent"]))
                          }, "Try again")
                        ]))
                      : (_ctx.digest)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.digest.summary)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.digest.summary), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'fdd-chip-hot': _ctx.counts.overdue })
                              }, _toDisplayString(_ctx.counts.overdue || 0) + " overdue", 3),
                              _createElementVNode("span", null, _toDisplayString(_ctx.counts.dueToday || 0) + " due today", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.counts.dueThisWeek || 0) + " due this week", 1),
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'fdd-chip-warn': _ctx.counts.noDueDate })
                              }, _toDisplayString(_ctx.counts.noDueDate || 0) + " with no due date", 3),
                              (_ctx.milestoneChip)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(_ctx.milestoneChip.cls)
                                  }, _toDisplayString(_ctx.milestoneChip.text), 3))
                                : _createCommentVNode("", true),
                              (_ctx.rockCounts.rocks)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    class: _normalizeClass({ 'fdd-chip-warn': _ctx.rockCounts.off })
                                  }, _toDisplayString(_ctx.rockChip), 3))
                                : _createCommentVNode("", true),
                              (_ctx.signCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.signCount) + " to sign", 1))
                                : _createCommentVNode("", true),
                              (_ctx.handoffCount)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.handoffChip), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.boardActions)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "fdd-label" }, "For this deck · the Forge", -1)),
                                  _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ai-btn ai-btn-ghost fdd-small",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.forge('tidyboard')))
                                    }, [...(_cache[19] || (_cache[19] = [
                                      _createElementVNode("b", null, "Tidy my board", -1),
                                      _createElementVNode("span", null, "Overdue, stale, undated cards", -1)
                                    ]))]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ai-btn ai-btn-ghost fdd-small",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.forge('planweek')))
                                    }, [...(_cache[20] || (_cache[20] = [
                                      _createElementVNode("b", null, "Plan my week", -1),
                                      _createElementVNode("span", null, "What to focus on", -1)
                                    ]))]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ai-btn ai-btn-ghost fdd-small",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.forge('sortinbox')))
                                    }, [...(_cache[21] || (_cache[21] = [
                                      _createElementVNode("b", null, "Sort the Inbox", -1),
                                      _createElementVNode("span", null, "Titles, columns, dates", -1)
                                    ]))])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.meetings.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "fdd-label" }, "Meetings", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetings, (m) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      key: m.meetingID + m.when,
                                      href: "#",
                                      class: "fdd-row",
                                      onClick: _withModifiers(($event: any) => (_ctx.openMeeting(m)), ["prevent"])
                                    }, [
                                      _createElementVNode("span", _hoisted_24, [
                                        _createTextVNode(_toDisplayString(m.when == 'today' ? 'Today' : 'Tomorrow'), 1),
                                        (m.time)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(_ctx.timeLabel(m.time)), 1)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("span", _hoisted_25, [
                                        _createElementVNode("b", null, _toDisplayString(m.name), 1),
                                        (m.note)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(m.note), 1))
                                          : (m.team)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(m.team), 1))
                                            : _createCommentVNode("", true)
                                      ])
                                    ], 8, _hoisted_23))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.digest.urgent.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "fdd-label" }, "Most urgent", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.digest.urgent, (u) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      key: u.ref,
                                      href: "#",
                                      class: "fdd-row",
                                      onClick: _withModifiers(($event: any) => (_ctx.openItem(u)), ["prevent"])
                                    }, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["fdd-when", { 'fdd-hot': u.bucket == 'overdue' }])
                                      }, _toDisplayString(u.bucket == 'overdue' ? 'Overdue' : u.bucket == 'today' ? 'Today' : _ctx.shortDate(u.due)), 3),
                                      _createElementVNode("span", _hoisted_30, [
                                        _createElementVNode("b", null, _toDisplayString(u.name), 1),
                                        _createElementVNode("span", null, _toDisplayString(u.where) + " · " + _toDisplayString(u.why), 1)
                                      ])
                                    ], 8, _hoisted_29))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.handoffCount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, "Recordings sent to you · " + _toDisplayString(_ctx.handoffCount), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.handoffs.items, (h) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      key: 'h' + h.jobID,
                                      href: "#",
                                      class: "fdd-row",
                                      onClick: _withModifiers(($event: any) => (_ctx.openLink(h.link)), ["prevent"])
                                    }, [
                                      _createElementVNode("span", _hoisted_34, _toDisplayString(h.saving ? 'Saving…' : 'To build'), 1),
                                      _createElementVNode("span", _hoisted_35, [
                                        _createElementVNode("b", null, "Screen recording from " + _toDisplayString(h.from), 1),
                                        _createElementVNode("span", null, [
                                          _createTextVNode(_toDisplayString(h.note || 'No note'), 1),
                                          (h.created)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" · sent " + _toDisplayString(_ctx.shortDate(String(h.created).slice(0, 10))), 1)
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ], 8, _hoisted_33))
                                  }), 128)),
                                  (_ctx.handoffCount > _ctx.handoffs.items.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createTextVNode(_toDisplayString(_ctx.handoffCount - _ctx.handoffs.items.length) + " more under ", 1),
                                        _createElementVNode("a", {
                                          href: "#",
                                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openLink('/ai-hub#captures')), ["prevent"]))
                                        }, "My captures"),
                                        _cache[25] || (_cache[25] = _createTextVNode(".", -1))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.rocks.items.length || _ctx.rocks.milestones.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("span", null, "Rocks · " + _toDisplayString(_ctx.rocks.quarter.label), 1),
                                    _createElementVNode("span", _hoisted_39, "Week " + _toDisplayString(_ctx.rocks.quarter.week) + " of " + _toDisplayString(_ctx.rocks.quarter.weeks) + " · " + _toDisplayString(_ctx.rocks.quarter.daysLeft) + " days left", 1)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rocks.items, (r) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      key: 'r' + r.rockID,
                                      href: "#",
                                      class: "fdd-row",
                                      onClick: _withModifiers(($event: any) => (_ctx.openLink(r.link)), ["prevent"])
                                    }, [
                                      _createElementVNode("span", _hoisted_41, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["fdd-pill", r.status == 'off' ? 'fdd-pill-bad' : 'fdd-pill-ok'])
                                        }, _toDisplayString(r.status == 'off' ? 'Off track' : 'On track'), 3)
                                      ]),
                                      _createElementVNode("span", _hoisted_42, [
                                        _createElementVNode("b", null, _toDisplayString(r.name), 1),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.rockLine(r)), 1)
                                      ])
                                    ], 8, _hoisted_40))
                                  }), 128)),
                                  (_ctx.rocks.milestones.length)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_43, "My milestones · " + _toDisplayString(_ctx.rocks.milestones.length), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rocks.milestones, (m) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: m.ref,
                                            class: "fdd-due"
                                          }, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["fdd-when", { 'fdd-hot': m.bucket == 'overdue' }])
                                            }, _toDisplayString(m.bucket == 'overdue' ? 'Overdue' : m.bucket == 'today' ? 'Today' : _ctx.shortDate(m.due)), 3),
                                            _createElementVNode("div", _hoisted_44, [
                                              _createElementVNode("a", {
                                                href: "#",
                                                onClick: _withModifiers(($event: any) => (_ctx.openLink(m.link)), ["prevent"])
                                              }, [
                                                _createElementVNode("b", null, _toDisplayString(m.name), 1)
                                              ], 8, _hoisted_45),
                                              _createElementVNode("span", null, [
                                                _createTextVNode(_toDisplayString(m.where), 1),
                                                (m.why)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createTextVNode(" · " + _toDisplayString(m.why), 1)
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              (m.error)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(m.error), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_47, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "ai-btn ai-btn-ghost fdd-small",
                                                disabled: _ctx.busy || m.saving,
                                                onClick: ($event: any) => (_ctx.milestoneDone(m))
                                              }, _toDisplayString(m.saving ? 'Saving…' : 'Done'), 9, _hoisted_48)
                                            ])
                                          ]))
                                        }), 128))
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (_ctx.rocks.more || _ctx.rockCounts.noMilestones)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                        (_ctx.rocks.more)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(_toDisplayString(_ctx.rocks.more) + " more on ", 1),
                                              _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.openLink(_ctx.myRocksLink)), ["prevent"]))
                                              }, "My rocks"),
                                              _cache[26] || (_cache[26] = _createTextVNode(".", -1))
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (_ctx.rockCounts.noMilestones)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createTextVNode(_toDisplayString(_ctx.rockCounts.noMilestones) + " of your rocks " + _toDisplayString(_ctx.rockCounts.noMilestones == 1 ? 'has' : 'have') + " no milestones yet: on ", 1),
                                              _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.openLink(_ctx.myRocksLink)), ["prevent"]))
                                              }, "the Rocks page"),
                                              _cache[27] || (_cache[27] = _createTextVNode(" the Forge can draft them.", -1))
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.digest.noDueDate.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _cache[28] || (_cache[28] = _createElementVNode("span", null, "No due date · the Forge suggests one", -1)),
                                    (_ctx.acceptable.length > 1)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "ai-btn ai-btn-ghost fdd-small",
                                          disabled: _ctx.busy,
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.acceptAll()))
                                        }, "Accept all " + _toDisplayString(_ctx.acceptable.length), 9, _hoisted_52))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.digest.noDueDate, (x) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: x.ref,
                                      class: "fdd-due"
                                    }, [
                                      _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("a", {
                                          href: "#",
                                          onClick: _withModifiers(($event: any) => (_ctx.openItem(x)), ["prevent"])
                                        }, [
                                          _createElementVNode("b", null, _toDisplayString(x.name), 1)
                                        ], 8, _hoisted_54),
                                        _createElementVNode("span", null, [
                                          _createTextVNode(_toDisplayString(x.kind == 'step' ? 'Checklist step on ' : '') + _toDisplayString(x.where), 1),
                                          (x.reason)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" · " + _toDisplayString(x.reason), 1)
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (x.error)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(x.error), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_56, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "date",
                                          "onUpdate:modelValue": ($event: any) => ((x.pick) = $event),
                                          min: _ctx.digest.date,
                                          "aria-label": 'Due date for ' + x.name
                                        }, null, 8, _hoisted_57), [
                                          [_vModelText, x.pick]
                                        ]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "ai-btn fdd-small",
                                          disabled: _ctx.busy || !x.pick || x.saving,
                                          onClick: ($event: any) => (_ctx.accept(x))
                                        }, _toDisplayString(x.saving ? 'Saving…' : 'Accept'), 9, _hoisted_58),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "fdd-x",
                                          title: "Not now: drop it from today's digest",
                                          disabled: _ctx.busy || x.saving,
                                          onClick: ($event: any) => (_ctx.skip(x))
                                        }, "×", 8, _hoisted_59)
                                      ])
                                    ]))
                                  }), 128)),
                                  (_ctx.digest.moreUndated)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.digest.moreUndated) + " more without a date. Tidy my board on each deck suggests dates for all of them.", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.signCount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, "Signatures needed · " + _toDisplayString(_ctx.signCount), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signatures.items, (n) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      key: n.slug,
                                      href: "#",
                                      class: "fdd-row",
                                      onClick: _withModifiers(($event: any) => (_ctx.openNode(n)), ["prevent"])
                                    }, [
                                      _createElementVNode("span", _hoisted_64, _toDisplayString(n.typeLabel), 1),
                                      _createElementVNode("span", _hoisted_65, [
                                        _createElementVNode("b", null, _toDisplayString(n.name), 1),
                                        _createElementVNode("span", null, [
                                          _createTextVNode(_toDisplayString(n.signedBefore ? 'Changed since you signed it' : 'Not signed yet'), 1),
                                          (n.lastModified)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" · updated " + _toDisplayString(_ctx.shortDate(String(n.lastModified).slice(0, 10))), 1)
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ], 8, _hoisted_63))
                                  }), 128)),
                                  (_ctx.signCount > _ctx.signatures.items.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.signCount - _ctx.signatures.items.length) + " more on your Home page.", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.digest.notes)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(_ctx.digest.notes), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.meetings.length && !_ctx.digest.urgent.length && !_ctx.digest.noDueDate.length && !_ctx.signCount && !_ctx.handoffCount && !_ctx.rocks.items.length && !_ctx.rocks.milestones.length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_68, "Nothing needs you right now."))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("span", _hoisted_70, "Made " + _toDisplayString(_ctx.madeAt) + ". Suggestions only: nothing changes until you accept it.", 1),
                              _createElementVNode("button", {
                                type: "button",
                                class: "ai-btn ai-btn-ghost fdd-small",
                                disabled: _ctx.busy || _ctx.refreshing,
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.refresh()))
                              }, _toDisplayString(_ctx.refreshing ? 'Refreshing…' : 'Refresh'), 9, _hoisted_71)
                            ]),
                            (_ctx.notice)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.notice), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                ])
              ], 544)
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}